var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8606 6.77002H8.15062C6.63062 6.77002 5.40062 8.00002 5.39062 9.53002V12.84C5.39062 14.36 6.62062 15.59 8.15062 15.6H11.4606V16.15H9.81063C9.51063 16.15 9.26063 16.4 9.26063 16.7C9.26063 17 9.51063 17.25 9.81063 17.25H14.2206C14.5206 17.25 14.7706 17 14.7706 16.7C14.7706 16.4 14.5206 16.15 14.2206 16.15H12.5706V15.6H15.8806C17.4006 15.6 18.6306 14.37 18.6406 12.84V9.53002C18.6406 8.01002 17.4106 6.78002 15.8806 6.77002H15.8606ZM17.5106 12.83C17.5106 13.74 16.7706 14.48 15.8606 14.48H8.15062C7.24062 14.48 6.50063 13.74 6.50063 12.83V9.52002C6.50063 8.61002 7.24062 7.87002 8.15062 7.87002H15.8606C16.7706 7.87002 17.5106 8.61002 17.5106 9.52002V12.83Z",
    fill: "#30322C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.addfa43d441bdee2332ce10f05068bb4.svg";
export { ForwardRef as ReactComponent };